import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * convert html to raw text
 */
@NgFilter({
    token: Token.RawTextFilter,
    dependencies: [
    ]
})
export class RawTextFilter {
    constructor() {
        return ((html: string) => {
            return String(html).replace(/<(?:.|\n)*?>/gm, "");
        }) as any;
    }

}
